/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { 
  Link,
  Typography,
  Button,
  TextField,
  Select,
  InputLabel,
  Chip,
  Tab,
} from "@mui/material";
import TabPanel from '@mui/lab/TabPanel';

export const StyledBreadCrumbContainer = styled('div')({
  height: '20px',
  width: '100%',
  backgroundColor: '#f5f5f8',
  padding: '10px 0px 10px 20px',
  borderColor: '#e0e0e0',
  borderWidth: '0px 0px 1px 0px',
  borderStyle: 'solid',
})

export const StyledLink = styled(Link)(({ color }) => ({
  textDecoration: 'none',
  color: color,
  fontSize: '13px',
  fontWeight: '400',
}))

export const StyledTitleContainer = styled('div')({
  padding: '20px 0px 10px 0px',
})

export const StyledTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: '700',
  lineHeight: '40px',
})

export const StyledSearchBar = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '1px solid #2b4fb9 !important'
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: '1px',
    borderRadius: '25px',
  },
  '& .MuiInputBase-root': {
    borderRadius: '25px',
    height: '2.4rem',
    paddingTop: '3px',
    fontSize: '15px',
    width: '253px !important',
    backgroundColor: 'white',
    marginTop: '8px',
  },
})

export const StyledCreateButton = styled(Button)({
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
})

export const StyledCancelButton = styled(Button)({
  '&:hover': {
    textTransform: 'none',
    fontWeight: '600',
    boxShadow: 'none',
    border: '2px solid #001b59',
    borderRadius: '8px',
    color: '#001b59',
  },
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
  border: '2px solid #395bbd',
  borderRadius: '8px',
  color: '#395bbd',
})

export const StyledAddButton = styled(Button)({
  '&.Mui-disabled':{
    backgroundColor: '#001b59',
  },
  '&:hover': {
    textTransform: 'none',
    fontWeight: '600',
    boxShadow: 'none',
    backgroundColor: '#001b59',
    borderRadius: '8px',
    padding: '0px 30px',
  },
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
  backgroundColor: '#395bbd',
  borderRadius: '8px',
  padding: '0px 30px',
})

export const StyledButtonContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '15px 20px 5px 20px',
})

export const StyledCreateTitle = styled(Typography)({
  fontSize: '34px',
  fontWeight: '700',
  textWrap: 'nowrap',
  marginTop: '10px',
  textAlign: 'center',
})

export const StyledFormContainer = styled('div')({
  marginTop: '10%',
})

export const StyledFormFieldText = styled(Typography)({
  fontWeight: '600 !important',
  fontSize: '15px !important',
  marginBottom: '5px',
  color: 'rgba(81, 81, 82, 1);'
})

export const StyledTextField = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '2px solid #395bbd !important'
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: '8px'
  },
})

export const StyledHelperText = styled('span')({
  color: '#d32f2f',
  fontSize: '0.75rem',
  padding: '12px !important',
  letterSpacing: "0.3px",
  marginBottom: '10px',
})

export const StyledPhoneField = styled(PhoneInput)( ({borderColor}) => ({
  '&:hover':{
    '& .react-international-phone-input': {
      border: '2px solid #395bbd !important'
    },
  },
  '&:focus-within':{
    '& .react-international-phone-input': {
      border: '2px solid #1976d2 !important'
    },
  },
  '& .react-international-phone-input': {
    width: '100% !important',
    borderRadius: '0px 8px 8px 0px !important',
    height: '40px !important',
    borderColor: borderColor
  },
  '& .react-international-phone-country-selector-button': {
    height: '40px !important',
    borderRadius: '8px 0px 0px 8px !important',
    borderColor: borderColor
  }
}))

export const RestaurantAdminContainer = styled('div')({
  height: '100%',
  width: '100%',
  overflowY: 'scroll',
  overflowX: 'hidden',
})

export const StyledUpdateButton = styled(Button)({
  '&.Mui-disabled':{
    backgroundColor: '#001b59',
  },
  '&:hover': {
    textTransform: 'none',
    fontWeight: '600',
    boxShadow: 'none',
    backgroundColor: '#001b59',
    borderRadius: '8px',
  },
  textTransform: 'none',
  fontWeight: '600',
  boxShadow: 'none',
  backgroundColor: '#395bbd',
  borderRadius: '8px',
})

export const StyledSelect = styled(Select)({
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: '#395bbd',
    }
  },
  '& .MuiSelect-select': {
    minHeight: '40px !important',
    padding: '8px 32px 8px 14px !important',
    display: 'flex !important',
    alignItems: 'center !important',
    flexWrap: 'wrap !important',
    gap: '4px',
  },
  '& .MuiChip-root': {
    height: '24px',
    margin: '0 !important',
  },
  '& .MuiOutlinedInput-input': {
    padding: '0 !important',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px !important',
  }
})

export const StyledInputLabel = styled(InputLabel)({
  '&.MuiInputLabel-root': {
    transform: 'translate(14px, 10px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(12px, -9px) scale(0.75)',
    },
    fontSize: '14px',
    backgroundColor: 'white',
    padding: '0 4px',
    zIndex: '-1',
  }
})

export const StyledAddInstanceButton = styled('div')({
  '&:hover': {
    backgroundColor: '#edf4fc',
  },
  border: '1px dotted #1976d2',
  height: '40px',
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
   cursor: 'pointer',
})

export const AddInstanceButtonText = styled('p')({
  fontSize: '15px',
  color: '#1976d2',
})

export const StyledInstanceContainer = styled('div')({
  height: '50px',
  marginBottom: '10px',
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px 10px 0px 5px',
  backgroundColor: '#edf4fc',
})

export const StyledInstanceWrapper = styled('div')({
  width: '100%',
  display: 'flex',
  gap: '5px',
  alignItems: 'center',
})

export const StyledResourceSelect = styled(Select)({
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: '#395bbd',
    }
  },
  '& .MuiOutlinedInput-input': {
    width: '110px',
  },
  '&.MuiInputBase-root': {
    backgroundColor: 'white !important',
    borderRadius: '8px !important',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px !important',
  }
})

export const StyledInstanceTextField = styled(TextField)({
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '2px solid #395bbd !important'
    },
  },
  '& .MuiInputBase-input': {
    height: '4px !important',
    backgroundColor: 'white',
    borderRadius: '8px',
    paddingTop: '19px'
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderWidth: "1px",
    borderRadius: '8px'
  },
})

export const StyledRoleSelect = styled(Select)({
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: '#395bbd',
    }
  },
  '& .MuiOutlinedInput-input': {
    width: '110px',
  },
  '&.MuiInputBase-root': {
    backgroundColor: 'white !important',
    borderRadius: '8px !important',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px !important',
  }
})

export const StyledChip = styled(Chip)({
  '& .MuiChip-deleteIcon': {
    color: '#9cbddf !important',
  },
  backgroundColor: '#edf4fc',
})


export const StyledInstanceSelect = styled(Select)({
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
      borderStyle: 'solid',
      borderColor: '#395bbd',
    }
  },
  '& .MuiOutlinedInput-input': {
    width: '110px',
  },
  '&.MuiInputBase-root': {
    backgroundColor: 'white !important',
    borderRadius: '8px !important',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px !important',
  }
})

export const StyledTab = styled(Tab)({
  textTransform: 'none',
  fontSize: '15px',
})

export const StyledTabPanel = styled(TabPanel)({
  padding: '25px 0px',
})
